// AWS Amplify Configuration for Cognito Authentication
// This replaces Supabase Auth

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_oM6HAW0Y9',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '66lntro8isaf3hj3id4ivsglh0'
    }
  }
};

// API Base URL - AWS API Gateway endpoint
export const API_BASE_URL = (process.env.REACT_APP_API_URL || 'https://lkonustfc4.execute-api.us-east-1.amazonaws.com/prod/api').trim();

export default awsConfig;
